import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import styles from './index.module.scss';

const EventTimeWarning = () => {
  return (
    <div className={styles.timeWarning}>
      <ErrorOutlineOutlinedIcon className={'text-neutrals-n-300 mr-1'} />
      In case you want to change the event time, the event must be voided.
    </div>
  );
};

export default EventTimeWarning;
